import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getClineInstructions = (playground, bearerToken, mcpServerUrl) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let userInterfaceInstructions = ``;
  let authInfo = ``;
  if (playground.authType === PlaygroundAuthType.BEARER_TOKEN) {
    authInfo = `,
      "headers": {
        "Authorization": "Bearer ${
          bearerToken ? bearerToken : "<YOUR_API_KEY>"
        }"
      }`;
  } else {
    userInterfaceInstructions = `
## Add via the User Interface

1. Click the "MCP Servers" icon in the top navigation bar of the Cline extension. 

![](/app/images/screens/cline_setup_1.png)

2. Select the "Remote Servers" tab, add the MCP server name and the URL below and click "Add Server".

Server Name: \`${sanitizeName(playground.name)}\`

Server URL: \`${mcpServerUrl}\`

![](/app/images/screens/cline_setup_2.png)
    `;
  }

  const result = `

${oauthNote}⚠️ Note: At the moment of writing, Cline does not support MCP servers that use the HTTP stream transport.

${userInterfaceInstructions}

## Add via Configuration File

To add an MCP server to your Cline configuration:

1. Click the MCP Servers icon at the top navigation bar of the Cline pane.

1. Select the "Installed" tab.

1. Click the “Configure MCP Servers” button at the bottom of the pane to open the MCP configuration file in the editor. The file uses a JSON format with a mcpServers object containing named server configurations.

1. Edit the configuration and add the following server entry to it:

\`\`\`json
{
  "mcpServers": {
    "${sanitizeName(playground.name)}": {     
      "url": "${mcpServerUrl}"${authInfo}
    }
  }
}
\`\`\`


For further details, see [the official documentation here](https://docs.cline.bot/mcp/configuring-mcp-servers).

`;

  return result;
};

export default getClineInstructions;
